import { CALL_API } from "../../middlewares/api";

export const CREATE_BORROWER_NOTE_REQUEST = "CREATE_BORROWER_NOTE_REQUEST";
export const CREATE_BORROWER_NOTE_SUCCESS = "CREATE_BORROWER_NOTE_SUCCESS";
export const CREATE_BORROWER_NOTE_ERROR = "CREATE_BORROWER_NOTE_ERROR";

export const CREATE_INVESTOR_NOTE_REQUEST = "CREATE_INVESTOR_NOTE_REQUEST";
export const CREATE_INVESTOR_NOTE_SUCCESS = "CREATE_INVESTOR_NOTE_SUCCESS";
export const CREATE_INVESTOR_NOTE_ERROR = "CREATE_INVESTOR_NOTE_ERROR";

export function create_note(clientId, Text, Type, isInvestor = false) {
  const endpoint = isInvestor ? "/investors/add-note" : "/borrowers/add-note";
  let clientType = isInvestor ? "InvestorId" : "BorrowerId";
  const types = isInvestor
    ? [
        CREATE_INVESTOR_NOTE_REQUEST,
        CREATE_INVESTOR_NOTE_SUCCESS,
        CREATE_INVESTOR_NOTE_ERROR,
      ]
    : [
        CREATE_BORROWER_NOTE_REQUEST,
        CREATE_BORROWER_NOTE_SUCCESS,
        CREATE_BORROWER_NOTE_ERROR,
      ];

  return {
    [CALL_API]: {
      endpoint: "/api/admin" + endpoint,
      method: "POST",
      authenticatedRequest: true,
      data: { [clientType]: clientId, Text, Type },
      types: types,
    },
  };
}
